module.exports = __webpack_public_path__ + "static/img/bg-pt.79ffc966.png";